import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { BaseService } from "./base.service";
import { ICountry } from "../interfaces/icountry";
import { ICountryContentStatus, ICountryDataList } from "../interfaces/icountrycontentstatus";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";

@Injectable()
export class CountryService extends BaseService {
    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    getCountries(): Observable<ICountry[]> {
        return super.get("/api/country").pipe(
            map((res: any) => res as ICountry[])
        );
    }

    getCountriesWithContentStatus(): Observable<ICountryDataList> {
        return super.get("/api/country/getwithstatus").pipe(
            map((res: any) => res as ICountryDataList)
        );
    }
    
    putDisableEnableCountries(country: string): Observable<ICountryDataList> {
        return super.put("/api/country/putdisableorenablecountries/", JSON.stringify(country)).pipe(
            map((res: any) => res as ICountryDataList)
        );
    }
    
    removeCountryContent(countryID: string): Observable<ICountryDataList> {
        return super.put("/api/country/removeCountryContent/", JSON.stringify(countryID)).pipe(
            map((res: any) => res as ICountryDataList)
        );
    }
}




